import { Navigate } from "react-router-dom";
import { Skeleton } from "@/components/ui/skeleton";
import { usePermissions } from "@/hooks/usePermissions";
import { getDefaultSettingsSection } from "./settings-section-access";

export function SettingsIndexRedirect() {
  const { isOrgAdmin, isSuperAdmin, isLoading } = usePermissions();

  if (isLoading) {
    return <Skeleton className="h-64 w-full" />;
  }

  return (
    <Navigate
      to={`/settings/${getDefaultSettingsSection({ isAdmin: isOrgAdmin || isSuperAdmin })}`}
      replace
    />
  );
}
